module.exports = __webpack_public_path__ + "media/images/country_flags/dm-0494dd472d17c495da4faf5ffffbe1ec.png";